module.exports = __webpack_public_path__ + "img/heart.9c93f38e.png";